module.exports = {"532625101":"马白镇","532625102":"八寨镇","532625103":"仁和镇","532625104":"木厂镇","532625105":"夹寒箐镇","532625106":"小坝子镇","532625107":"都龙镇","532625108":"金厂镇","532625109":"坡脚镇","532625201":"南捞乡","532625202":"大栗树乡","532625203":"篾厂乡","532625204":"古林箐乡","532625501":"健康农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/532625.json
// module id = 2450
// module chunks = 0